<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {NumbersSlice} from '@prismicio-types';
    import NumbersDefault from './variations/NumbersDefault.vue';
    import NumbersKeyFigures from './variations/NumbersKeyFigures.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<NumbersSlice>());

    const variationComponents = {
        default: NumbersDefault,
        numbersKeyFigures: NumbersKeyFigures,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
